import {
  createRootRoute,
  Outlet,
  ErrorComponentProps,
} from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/router-devtools";
import ThemeProvider from "@/components/theme-provider";
import { ThemeAwareToaster } from "@/components/theme-aware-toaster";
import { Analytics } from "@vercel/analytics/react";
import { PermissionsProvider } from "@/components/context/permissions-provider";
import { SidebarProvider } from "@/components/context/sidebar-context";
import { CommandMenuProvider } from "@/components/context/command-menu-context";
import { ErrorComponent } from "@/components/errors/error-component";
import { LocaleSync } from "@/components/locale-sync";
import VersionCheck from "@/components/layout/version-check";

function RootComponent() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <PermissionsProvider>
        <CommandMenuProvider>
          <SidebarProvider>
            {/* Sincronizar preferencias de idioma del usuario */}
            <LocaleSync />

            <div className="min-h-screen bg-accent/50">
              <Outlet />
            </div>

            <Analytics />
            <ThemeAwareToaster />
            <VersionCheck />
          </SidebarProvider>
        </CommandMenuProvider>
      </PermissionsProvider>
      {/*{import.meta.env.DEV && (
        <TanStackRouterDevtools initialIsOpen={false} position="bottom-right" />
      )}*/}
    </ThemeProvider>
  );
}

function RootErrorComponent({ error, reset }: ErrorComponentProps) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      <div className="min-h-screen bg-accent/50 overflow-x-hidden">
        <ErrorComponent
          error={error}
          reset={reset}
          context={{
            route: "/__root",
          }}
        />
      </div>
      <ThemeAwareToaster />
    </ThemeProvider>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: RootErrorComponent,
});
